


import vue from 'vue'

import './app-imports.js'
import store from './app-store.js'
import router from './app-router.js'
import app from './app.vue'

vue.config.productionTip = false

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;



new vue({
	el : '#app',
	router : router,
	template : '<app/>',
	components : {
		app
	},
	data : {
		store : store
	}
})



// WEBPACK FOOTER //
// ./src/app.js